/**
 * Pure wording helpers for the stylists CSV import. Importing a stylist
 * creates their login, which emails them an invitation straight away, so the
 * dialog is explicit about that before and after.
 */

function plural(count, singular, pluralForm) {
  return count === 1 ? singular : pluralForm;
}

/** Warning shown in the preview, above the rows. Empty when nothing is valid. */
export function invitationNotice(validRows) {
  if (!validRows) return "";
  return validRows === 1
    ? "1 invitation email will be sent as soon as you import. The stylist receives a temporary password."
    : `${validRows} invitation emails will be sent as soon as you import. Each stylist receives a temporary password.`;
}

export function importButtonLabel(validRows) {
  return `Import and send ${plural(validRows, "invitation", "invitations")} (${validRows})`;
}

export function successMessage(importResult) {
  const count = importResult?.inserted ?? 0;
  return `${count} ${plural(count, "stylist", "stylists")} imported and invited`;
}

/** Sentence about generated barcodes for the results screen. Empty when there are none. */
export function barcodeNote(importResult) {
  const count = importResult?.barcodes_generated ?? 0;
  if (!count) return "";
  return `${count} ${plural(count, "barcode was", "barcodes were")} generated. Open a stylist's edit page to view and print their barcode.`;
}
